import { render, staticRenderFns } from "./OnboardingIntegrationBox.vue?vue&type=template&id=020e99cb&scoped=true&"
import script from "./OnboardingIntegrationBox.vue?vue&type=script&lang=js&"
export * from "./OnboardingIntegrationBox.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingIntegrationBox.vue?vue&type=style&index=0&id=020e99cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020e99cb",
  null
  
)

export default component.exports